import apiService from '@/api/apiService';

// 修改後台管理員密碼
export const resetAdminPassword = async ({ old_password, new_password }) => {
    const url = '/api/admin/reset-password';

    return apiService.PUT(url, {
        old_password,
        new_password
    });
};
